import {
  RadarChart as RechartsRadar,
  PolarGrid,
  PolarAngleAxis,
  PolarRadiusAxis,
  Radar,
  ResponsiveContainer,
  Tooltip,
} from "recharts";
import { CATEGORY_COLORS } from "../../lib/utils";

export function RadarChart({ data, className }) {
  // Transform data for Recharts
  const chartData = data.map((item) => ({
    category: item.category_name?.split(" ")[0] || item.name?.split(" ")[0] || "Unknown",
    fullName: item.category_name || item.name,
    score: item.average || item.score || 0,
    fill: CATEGORY_COLORS[item.category_id || item.id] || "#2C3E50",
  }));

  return (
    <div className={className} data-testid="radar-chart">
      <ResponsiveContainer width="100%" height="100%">
        <RechartsRadar data={chartData} margin={{ top: 20, right: 30, bottom: 20, left: 30 }}>
          <PolarGrid stroke="hsl(var(--border))" />
          <PolarAngleAxis
            dataKey="category"
            tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 12 }}
          />
          <PolarRadiusAxis
            angle={90}
            domain={[0, 10]}
            tick={{ fill: "hsl(var(--muted-foreground))", fontSize: 10 }}
            tickCount={6}
          />
          <Radar
            name="Score"
            dataKey="score"
            stroke="hsl(var(--primary))"
            fill="hsl(var(--primary))"
            fillOpacity={0.4}
            strokeWidth={2}
          />
          <Tooltip
            content={({ active, payload }) => {
              if (active && payload && payload.length) {
                const data = payload[0].payload;
                return (
                  <div className="bg-popover border rounded-lg shadow-lg p-3">
                    <p className="font-medium">{data.fullName}</p>
                    <p className="text-sm text-muted-foreground">
                      Score: <span className="font-semibold text-foreground">{data.score.toFixed(1)}</span>
                    </p>
                  </div>
                );
              }
              return null;
            }}
          />
        </RechartsRadar>
      </ResponsiveContainer>
    </div>
  );
}
